import { Routes } from '@angular/router';
import { ScopeGuard } from '../auth/services/scope.guard';
import { SCOPES } from 'src/app/app.constants';

export const SETTINGS_ROUTES: Routes = [
  {
    path: 'all',
    loadComponent: () =>
      import('./components/settings-list/settings-list.component').then((m) => m.SettingsListComponent),
  },
  {
    path: 'local',
    loadComponent: () =>
      import('./components/local-settings/local-settings.component').then((m) => m.LocalSettingsComponent),
  },
  {
    path: 'operations',
    canActivate: [ScopeGuard],
    data: { scopes: [SCOPES.operations.settings.manage] },
    loadComponent: () =>
      import('./components/operations-settings/operations-settings.component').then(
        (m) => m.OperationsSettingsComponent
      ),
  },
  {
    path: 'pipelines/:id',
    canActivate: [ScopeGuard],
    data: { scopes: [SCOPES.admin.pipelines.manage] },
    loadComponent: () =>
      import('./components/pipeline-settings/components/pipeline-details/pipeline-details.component').then(
        (m) => m.PipelineDetailsComponent
      ),
  },
  {
    path: 'pipelines',
    canActivate: [ScopeGuard],
    data: { scopes: [SCOPES.admin.pipelines.manage] },
    loadComponent: () =>
      import('./components/pipeline-settings/pipeline-settings.component').then((m) => m.PipelineSettingsComponent),
  },
  {
    path: 'staff',
    canActivate: [ScopeGuard],
    data: { scopes: [SCOPES.admin.users.write] },
    loadComponent: () =>
      import('./components/staff-settings/staff-settings.component').then((m) => m.StaffSettingsComponent),
  },
  {
    path: 'training-calculation',
    canActivate: [ScopeGuard],
    data: { scopes: [SCOPES.training.calculationSettings.manage] },
    loadComponent: () =>
      import('./components/training-calculation-settings/training-calculation-settings.component').then(
        (m) => m.TrainingCalculationSettingsComponent
      ),
  },
  { path: 'sharepoint', loadChildren: () => import('./sharepoint.routes').then((m) => m.SHAREPOINT_ROUTES) },
];
